import React from "react";
import Head from "next/head";
import Layout from "components/Layout";
import { getByID as getPage } from "lib/models/Page";
import withGlobalFields from "lib/withGlobalFields";
import PageContent from "components/PageContent";

const Affiliates = (props) => (
  <Layout {...props.global}>
    <Head>
      <title>{`${props.fields.title} | ${props.global.seo.title}`}</title>
    </Head>

    <PageContent {...props.fields} />
  </Layout>
);

export const getStaticProps = withGlobalFields(async () => {
  const { fields } = await getPage("affiliates");

  return { props: { fields } };
});

export default Affiliates;
